<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1.00006C0 0.447776 0.447715 6.10352e-05 1 6.10352e-05H5C5.55228 6.10352e-05 6 0.447776 6 1.00006V5.00006C6 5.55235 5.55228 6.00006 5 6.00006H1C0.447715 6.00006 0 5.55235 0 5.00006V1.00006ZM8 1.00006C8 0.447776 8.44772 6.10352e-05 9 6.10352e-05H13C13.5523 6.10352e-05 14 0.447776 14 1.00006V5.00006C14 5.55235 13.5523 6.00006 13 6.00006H9C8.44772 6.00006 8 5.55235 8 5.00006V1.00006ZM1 8.00006C0.447715 8.00006 0 8.44778 0 9.00006V13.0001C0 13.5523 0.447716 14.0001 1 14.0001H13C13.5523 14.0001 14 13.5523 14 13.0001V9.00006C14 8.44778 13.5523 8.00006 13 8.00006H1Z"
      fill="currentColor"
    />
  </svg>
</template>
